<template>
  <div class="resetPasswordDoneContainer">
    <div class="grid imgGrid">
      <img class="imgContainer" src="@/assets/images/mosquita_rocket.png" />
      <p class="ralewayRegular subheaderText2">
        {{
          this.$route.query.changePassword
            ? $t('k_change_password_done')
            : $t('k_reset_password_done')
        }}
      </p>
    </div>
    <form action="#" @submit.prevent="submit">
      <div class="grid mt-10 stButtonGrid">
        <div class="stButton registerButton">
          <div
            class="stButtonCaption nunitoBold"
            v-on:click="$router.push('/login')"
          >
            {{ $t('k_continue_title') }}
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {}
</script>
<style lang="scss">
.resetPasswordDoneContainer {
  .registerButton {
    grid-row: 1;
    grid-column: 2/12;
    padding: 10px 0px;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  .buttonCaption {
    grid-row: 1;
    grid-column: 4/13;
    display: flex;
    font-size: 1.1875em;
  }

  .stButtonCaption {
    grid-row: 1;
    grid-column: 1/13;
    font-size: 1.1875em;
  }

  .formContainer {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  .formElement {
    grid-column: 2/12;
  }

  .formInputLabel {
    display: flex;
    font-size: 1em;
    color: var(--formColor);
  }
  .formInput {
    padding: 10px 15px;
    width: 100%;
    border-radius: 5px;
    border: 1px solid var(--outlineInput);
    font-size: 1em;
    color: var(--formColor);
  }

  .checkboxLabel {
    font-size: 0.688em;
    color: var(--formColor);
    grid-column: 3/8;
  }

  .accept {
    display: flex;
    grid-column: 2/3;
    align-self: center;
  }
  @media screen and (min-width: 620px) {
    .stButtonGrid {
      max-width: 600px;
      margin: auto;
    }

    .formContainer {
      max-width: 600px;
      margin: auto;
    }
  }
  /* large tablet and laptop styles */
  @media screen and (min-width: 960px) {
  }
  /* desktop styles */
  @media screen and (min-width: 1200px) {
  }
}
</style>
